<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div>
        <v-row>
            <v-col cols="auto">
                <v-btn
                    color="secondary"
                    depressed
                    :disabled="isReadOnly"
                    @click="handleOpenAddJobDefectDialog"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Wybierz wadliwy montaż w zleceniu
                </v-btn>
            </v-col>

            <v-col cols="auto">
                <v-btn
                    color="secondary"
                    depressed
                    :disabled="isReadOnly || !canPickOrderDefects"
                    @click="handleOpenAddOrderDefectDialog"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Wybierz wadliwy element zamówienia
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="9">
                <DefectsTable :complaint="complaint" />
            </v-col>
        </v-row>

        <AddJobDefectDialog
            :is-dialog-open="isAddJobDefectDialogOpen"
            :report-item="selectedReportItem"
            :complaint="complaint"
            :is-read-only="isReadOnly"
            @closeDialog="handleCloseAddJobDefectDialog"
        />

        <AddOrderDefectDialog
            :is-dialog-open="isAddOrderDefectDialogOpen"
            :report-item="selectedReportItem"
            :complaint="complaint"
            :selected-order-numbers="complaint.complaintOrderComplaint"
            :is-read-only="isReadOnly"
            @on-close="handleCloseAddOrderDefectDialog"
        />
    </div>
</template>

<script>
import DefectsTable from '../../DefectsTable.vue'
import AddJobDefectDialog from '../../Dialogs/AddJobDefectDialog.vue'
import AddOrderDefectDialog from '../../Dialogs/AddOrderDefectDialog.vue'

/* eslint-disable vue/no-mutating-props */
export default {
    name: 'DetailsTabDefectsSection',

    components: {
        DefectsTable,
        AddJobDefectDialog,
        AddOrderDefectDialog,
    },

    props: {
        complaint: {
            type: Object,
            required: true,
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    data() {
        return {
            isAddJobDefectDialogOpen: false,
            isAddOrderDefectDialogOpen: false,
        }
    },

    computed: {
        canPickOrderDefects() {
            return this.complaint.complaintOrderComplaint && this.complaint.complaintOrderComplaint.length
        },
        
        selectedReportItem() {
            const list = this.$store.state.complaints.internalComplaints.reportItems || []

            return list.find(item => item.primaryNumber === this.complaint.jobNumber) || null
        },
    },

    methods: {
        handleOpenAddJobDefectDialog() {
            this.isAddJobDefectDialogOpen = true
        },

        handleCloseAddJobDefectDialog() {
            this.isAddJobDefectDialogOpen = false
        },

        handleOpenAddOrderDefectDialog() {
            this.isAddOrderDefectDialogOpen = true
        },

        handleCloseAddOrderDefectDialog() {
            this.isAddOrderDefectDialogOpen = false
        },
    }
}
</script>
